import { Component, OnInit } from '@angular/core';
import { AccessDeniedService } from '../../services/access-denied.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {

  public message: string;

  constructor(private service: AccessDeniedService) { }

  ngOnInit(): void {
    this.message = this.service.message;
  }

}
